import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TopBar from '../../../componentsv2/TopBar';
import Skeleton from '../../../componentsv2/Skeleton';

export default function SignupSkeleton() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopBar>
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Skeleton width="180px" height="23px" />
        </Box>
      </TopBar>
      <Box component="main" sx={{ flexGrow: 1, paddingTop: '1em', display: 'flex' }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', justifyContent: 'center' }}
          >
            <Skeleton width="70%" height="360px" />
          </Grid>
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              backgroundColor: { xs: 'inherit', md: '#FBFCFE' },
              paddingBottom: '1em',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Grid container rowSpacing={2} justifyContent="center" sx={{ maxWidth: '70%', margin: 'auto' }}>
              <Grid item xs={12}>
                <Skeleton width="60%" height="36px" />
              </Grid>
              {[0, 1, 2, 3].map((row) => (
                <Grid item xs={12} key={row}>
                  <Skeleton width="100%" height="56px" />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Skeleton width="100%" height="48px" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
